import {Avatar} from "antd";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  .ant-select-dropdown {
    border-radius: 12px !important;
    overflow: hidden;
  }
`;

export const MapContainer = styled.div`
    width: 100%;
    height: ${props => props.$height || "650px"};
    overflow: hidden;
    border: 1px solid white;
    border-radius: 4px;
    z-index: 1;
    position: relative;
    /*            ^^ */
    ${({mode}) =>
        mode == "fixed" &&
        `position:fixed;
        left: 105px;
        right:25px;
        bottom:40px;
        top:95px;
        width:inherit;
        height:inherit;`}
`;

export const MapTools = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    background: white;
    border-radius: 16px;
    .ant-select {
        margin-right: 10px;
    }
`;

export const Marker = styled(Avatar)`
    position: absolute;
    background-color: ${props => props.color};
    transform: translate(-50%, -50%);
    border: 1px solid #021529;
    box-sizing: content-box;
    color: #021529;
    z-index: ${props => (props.$hover ? 2 : 1)};
    font-size: 14px !important;
    border-radius: ${props => props.$hover && "4px"};
    width: ${props => props.$hover && "auto"} !important;
    &:after {
        content: ${props => props.$hover && `"${props.text}"`};
        margin-left: 5px;
    }
    padding: ${props => props.$hover && "5px"} !important;
    transition: border-radius 0.1s;
`;

export const AnalysisPanelButton = styled.button`
    width: ${props => (props.$isVisible ? "32px" : "auto")};
    height: ${props => (props.$isVisible ? "32px" : "36px")};
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border: none;
    border-radius: ${props => (props.$isVisible ? "12px" : "12px")};
    cursor: pointer;
    margin-bottom: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    position: absolute;
    left: 0px;
    top: 10px;
    transition: all 0.3s ease;
    z-index: 1;
    padding: ${props => (props.$isVisible ? "0" : "0 0")};
    gap: 8px;
    padding: 16px;

    &:hover {
        background: #fafafa;
    }
`;

export const AnalysisPanelContainer = styled.div`
    width: 320px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;
    padding: 16px;
`;

export const ResolutionSection = styled.div`
    padding: 0px;
`;

export const ResolutionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
`;

export const ResolutionTitle = styled.h4`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #111;
`;

export const ResolutionDescription = styled.p`
    margin: 6px 0 0 0;
    font-size: 13px;
    color: #666;
    line-height: 1.4;
`;

export const ResolutionBadge = styled.div`
    background: ${props =>
        props.$resolution <= 4 ? "#fff7e6" : props.$resolution <= 6 ? "#e6f7ff" : "#f6ffed"};
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    color: ${props =>
        props.$resolution <= 4 ? "#d46b08" : props.$resolution <= 6 ? "#096dd9" : "#389e0d"};
`;

export const HexagonList = styled.div`
    overflow-y: auto;
    margin-top: 8px;
    max-height: 330px;
    &.hide-scroll {
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display: none;
        }
    }
`;

export const HexagonGroup = styled.div`
    background: #fff;
    border-radius: 12px;
    border: 1px solid #f0f0f0;
    margin-bottom: 8px;
`;

export const HexagonGroupHeader = styled.div`
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: ${props => (props.$isExpanded ? "1px solid #f0f0f0" : "none")};
    cursor: pointer;
    user-select: none;
`;

export const HexagonItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: ${props => {
        if (props.$isSelected) return "#f0f5ff";
        if (props.$isHovered) return "#f5f5f5";
        return "#fff";
    }};
    cursor: ${props => (props.$isDisabled ? "not-allowed" : "pointer")};
    opacity: ${props => (props.$isDisabled ? 0.5 : 1)};
    border-radius: 4px;

    &:hover {
        background: ${props => (props.$isSelected ? "#f0f5ff" : "#f5f5f5")};
    }
`;

export const HexagonCode = styled.div`
    font-size: 12px;
    font-family: monospace;
    color: #262626;
    font-weight: 500;
    letter-spacing: 0.2px;
`;

export const CompanyCount = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    background: #f0f7ff;
    padding: 4px 8px;
    border-radius: 4px;
    border: 1px solid #e6f7ff;
`;

export const CompanyList = styled.div`
    margin-top: 4px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    overflow: hidden;
`;

export const CompanyListHeader = styled.div`
    padding: 10px 12px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 6px;
    background: #fafafa;
`;

export const CompanyItem = styled.div`
    padding: 8px 12px;
    font-size: 12px;
    color: #595959;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        background: #f0f7ff;
        color: #40a9ff;
    }
`;